import { NormalizedRole } from "./types";

export const rolesRanks: Record<NormalizedRole, number> = {
  owner: 5,
  admin: 4,
  store: 3,
  customersupport: 2,
  logistician: 1,
};
